import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// CONSTANTS
import { APPS_GET_FILTERS, APPS_GET, APPS_GET_TOP } from '@/constants/api';

// UTILITY
import { getSerializedParams } from '@/utility/routes';
import { getPartnerSlug, showErrorNotification } from '@/utility/saga';

// STORE
import { AppsActions } from '@/store/actions';

const { getAppsFilters, getApps, getAppsTop, appsAutocomplete } = AppsActions;

export function* getAppsFiltersSaga() {
  yield put(getAppsFilters.start());

  try {
    const { data: respData } = yield axios.get(APPS_GET_FILTERS);

    yield put(getAppsFilters.success({ data: respData }));
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(getAppsFilters.fail());
  }
}

export function* getAppsSaga(action) {
  yield put(getApps.start());

  const { data } = action.payload;
  const partner = yield call(getPartnerSlug);
  const serializedParams = getSerializedParams({ ...data, partner });

  try {
    const { data: respData } = yield axios.get(APPS_GET, serializedParams);

    yield put(getApps.success({ data: respData.data }));
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(getApps.fail());
  }
}

export function* getTopAppsSaga(action) {
  yield put(getAppsTop.start());

  const { data } = action.payload;
  const partner = yield call(getPartnerSlug);
  const serializedParams = getSerializedParams({ ...data, partner });

  try {
    const { data: respData } = yield axios.get(APPS_GET_TOP, serializedParams);

    yield put(
      getAppsTop.success({
        data: respData.data,
      }),
    );
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(getAppsTop.fail());
  }
}

export function* appsAutocompleteSaga(action) {
  yield put(appsAutocomplete.start());

  const { data } = action.payload;
  const partner = yield call(getPartnerSlug);
  const serializedParams = getSerializedParams({ ...data, partner, limit: 15 });
  const hasSearch = 'search' in data && !!data.search;

  try {
    const { data: respData } = yield axios.get(APPS_GET, serializedParams);

    yield put(
      appsAutocomplete.success({
        data: respData.data,
        defData: !hasSearch ? respData.data : [],
      }),
    );
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put(appsAutocomplete.fail());
  }
}
